import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaUserProfile = React.lazy(() =>
    import('../NebulaUserProfile')
);
const nebulaUserProfileRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_USER_PROFILE_PAGE,
        element: <NebulaUserProfile />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaUserProfileRoutesRegistry;
